import { render, staticRenderFns } from "./LoaderDialog.vue?vue&type=template&id=6c2b858a&scoped=true&"
import script from "./LoaderDialog.vue?vue&type=script&lang=js&"
export * from "./LoaderDialog.vue?vue&type=script&lang=js&"
import style0 from "./LoaderDialog.vue?vue&type=style&index=0&id=6c2b858a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2b858a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VDialog,VProgressCircular})
